
import { Component } from 'nuxt-property-decorator'
import DefaultLayout from '~/layouts/default.vue'

@Component({
  components: {
  },
})
export default class NoFooterLayout extends DefaultLayout {
  get headerType () {
    return this.localeRoute('order-slug')?.name === this.$route.name ? 'navigation-less' : 'default'
  }
}
